// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"45a48e56b12df7fa6426","293":"95a29d92d5c0a49c4114","454":"82b02beae0d59d4cb3b9"}[chunkId] + ".js";
};